<template>
    <div>
        <div class="banner" :style="style" v-responsive.lg.xl>
            <div class="banner-filter"></div>
            <div class="banner-title policeLato">
                <template >
                    <span 
                        v-for="(label, index) in splitTitle" 
                        :key="index" 
                        :class="`${index}` == '0' ? 'white-title' : 'orange-title'"
                    >
                        {{ label }}
                    </span><br />
                </template>
            </div>
        </div>
        <div class="banner-mobile" :style="style" v-responsive.sm.xs>
            <div class="banner-mobile-filter"></div>
            <div class="banner-mobile-title policeLato">
                <template >
                    <span 
                        v-for="(label, index) in splitTitle" 
                        :key="index" 
                        :class="`${index}` == '0' ? 'white-title' : 'orange-title'"
                    >
                        {{ label }}
                    </span><br />
                </template>
            </div>
        </div>
    </div>
   
</template>

<script>
export default {
    name: 'Banner',
    props: {
        title: String,
        imagePath: String
    },
    computed: {
        splitTitle() {
            return this.title.split(' ')
        },

        imageSource() {
            return this.imagePath
        },

        style: function () {
            const style = {}
            style.backgroundImage = `url(${require('@/assets/img/' + this.imageSource)})`
            style.backgroundSize = '100% 35%'
            style.backgroundAttachment = 'fixed'
            style.backgroundPositionY = '60px'

            return style
        }
    },
}
</script>

<style scoped>
.banner {
    height: 250px;
    /* background-image: url('../../assets/img/assurance/voyage.jpg'); */
    position: relative;
}
.banner-filter {
    height: inherit;
    background-color: rgba(0, 0, 0, 0.5);
}
.banner-title {
    position: absolute;
    top: 47%;
    left: 9.5%;
    font-size: 3.8em;
    line-height: 0.9em;
    font-weight: 700;
}

.banner-title .white-title {
    color: #fff;
    display: block;
}

.banner-title .orange-title {
    color: #ffa409;
}






.banner-mobile {
    height: 150px;
    margin-top: 45px;
    /* background-image: url('../../assets/img/assurance/voyage.jpg'); */
    position: relative;
}
.banner-mobile-filter {
    height: inherit;
    background-color: rgba(0, 0, 0, 0.5);
}
.banner-mobile-title {
    position: absolute;
    top: 47%;
    left: 9.5%;
    font-size: 20px;
    line-height: 0.9em;
    font-weight: 700;
}

.banner-mobile-title .white-title {
    color: #fff;
    display: block;
}

.banner-mobile-title .orange-title {
    color: #ffa409;
}
</style>
